// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"248":"93deee5748f62f8bdfc8","372":"5bbb9c8acc0e228bf2cf","926":"d0d3c57d9dbedd989fd5"}[chunkId] + ".chunk.js";
};